import { useContext } from 'react'
import HelpContext from '../HelpContext'

const useHelpContext = () => useContext(HelpContext)

export default useHelpContext
